import React from 'react';
import { Colorway } from '@uds/theme-utils';

import useStylesheet from './WideTableRow.stylesheet';
import WideCell from './WideCell';
import { CellProps } from './Cell';

interface OuterProps {
  colorway: Colorway;
  row: Array<CellProps>;
  isOdd: boolean;
  isLast: boolean;
}

declare const j: number;
declare const cell: CellProps;

const PureWideTableRow = ({ colorway, row, isOdd, isLast }: OuterProps) => {
  const { styles } = useStylesheet({
    isOdd,
    isLast,
  });
  return (
    <div style={styles.tbodyRow}>
      <For each="cell" of={row} index="j">
        <div style={styles.cell} key={j}>
          <WideCell colorway={colorway} cell={cell} first={j === 0} last={j === row.length - 1} />
        </div>
      </For>
    </div>
  );
};

PureWideTableRow.displayName = 'WideTableRow';

export default PureWideTableRow;
